// 9fbef606107a605d69c0edbcd8029e5d
import { call, takeLatest, put, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { validateReduxCache } from '@tcp/core/src/utils/cache.util';
import { getAccountDashboardOrdersCacheTTL } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getOrderListByShipment } from '@tcp/core/src/services/abstractors/account/ordersList';
import constants from '../OrdersTile.constants';
import { showLoader, hideLoader, setOrderListByShipment } from './OrdersTile.actions';

export function* getOrderListByShipments({ payload }) {
  const { siteId, currentSiteId, reqParams = {} } = payload;
  try {
    yield put(showLoader());
    const orders = yield call(getOrderListByShipment, siteId, currentSiteId, reqParams);
    const cacheTTL = yield select(getAccountDashboardOrdersCacheTTL);

    yield put(setOrderListByShipment({ orders, cacheTTL }));
  } catch (e) {
    logger.error(constants.LOGGER_ERROR_MESSAGE, {
      error: e,
      extraData: {
        component: 'Orders Saga - getOrderListByShipments',
        payloadRecieved: payload,
      },
    });
  } finally {
    yield put(hideLoader());
  }
}

/**
 * @function OrdersTileSaga
 * @description watcher function for fetch orders.
 */
export function* OrdersTileSaga() {
  const cachedOrderListByShipments = validateReduxCache(getOrderListByShipments);
  yield takeLatest(constants.GET_ORDERS_LIST_BY_SHIPMENT, cachedOrderListByShipments);
}

export default OrdersTileSaga;
